import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
// Pages
import { Home } from './pages/Home';
import { ServicesPage } from './pages/ServicesPage';
import { PricingPage } from './pages/PricingPage';
import { About } from './pages/About';
import { Careers } from './pages/Careers';
import { Contact } from './pages/Contact';
// ScrollToTop utility to ensure pages start at the top when navigating
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <div className="min-h-screen bg-bg font-sans selection:bg-blue-soft selection:text-navy flex flex-col" data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Navbar data-id="element-2" />
      <div className="flex-grow" data-id="element-3">
        <Routes data-id="element-4">
          <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="/services" element={<ServicesPage data-id="element-8" />} data-id="element-7" />
          <Route path="/pricing" element={<PricingPage data-id="element-10" />} data-id="element-9" />
          <Route path="/about" element={<About data-id="element-12" />} data-id="element-11" />
          <Route path="/careers" element={<Careers data-id="element-14" />} data-id="element-13" />
          <Route path="/contact" element={<Contact data-id="element-16" />} data-id="element-15" />
        </Routes>
      </div>
      <Footer data-id="element-17" />
    </div>;
}